import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuthentication } from "./useAuthentication";

const LoginRedirect = () => {
  const { redirectLogin } = useAuthentication();
  const { inProgress, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    if (accounts.length > 0) {
      navigate("/app/home", { replace: true });
      return;
    }

    redirectLogin();
  }, [inProgress, accounts, redirectLogin, navigate]);

  return (
    <div className="flex flex-col justify-center items-center h-screen gap-2">
      <CircularProgress />
      <span>Redirecting to sign in...</span>
    </div>
  );
};

export default LoginRedirect;
